// Mock data for the marketplace
export interface Product {
  id: string
  name: string
  description: string
  shortDescription: string
  image: string
  price: string
  purchaseLink: string
  category: string
  reviews: Review[]
  ingredients?: string
}
export interface Review {
  id: string
  dietitianName: string
  credentials: string
  rating: number
  comment: string
  date: string
}
export const products: Product[] = [
  {
    id: '1',
    name: 'Organic Protein Powder',
    shortDescription: 'Plant-based protein with no artificial ingredients',
    description:
      'Our organic plant-based protein powder delivers 25g of complete protein per serving with a smooth texture and delicious taste. Made from a blend of pea, hemp, and brown rice protein with no artificial sweeteners, flavors, or preservatives.',
    image:
      'https://orgain.com/cdn/shop/files/851770003179-v13-Orgain-ProteinPowder-2.03lb-Chocolate-20240311-Front-HIRES-web_1200px.webp?v=1729013192&width=1920',
    price: '$37.99',
    purchaseLink: 'https://orgain.com/products/organic-protein-plant-based-protein-powder?srsltid=AfmBOorRjpq9lm6ubyWSaHAkYWq3-scMhcecNAAVW9ZE-Cs8jZFd2sAW',
    category: 'Supplements',
    ingredients:
      'Organic pea protein, organic hemp protein, organic brown rice protein, organic coconut sugar, organic cacao powder, organic vanilla flavor, sea salt, organic stevia leaf extract',
    reviews: [
      {
        id: 'r1',
        dietitianName: 'Dr. Sarah Johnson',
        credentials: 'PhD, RD, Sports Nutrition Specialist',
        rating: 5,
        comment:
          "One of the cleanest protein powders I've reviewed. Great amino acid profile and mixes well without the chalky texture common in plant proteins.",
        date: '2023-11-15',
      },
      {
        id: 'r2',
        dietitianName: 'Michael Chen',
        credentials: 'MS, RDN, CSSD',
        rating: 4,
        comment:
          'Excellent option for vegan athletes. The protein blend provides all essential amino acids and the minimal ingredient list is impressive.',
        date: '2023-10-22',
      },
    ],
  },
  {
    id: '2',
    name: 'AG1 Next Gen',
    shortDescription: 'Clinical-strength probiotics with prebiotic fiber',
    description:
      'AG1 Next Gen is a clinically-backed Daily Health Drink that combines a multivitamin, pre- and probiotics, superfoods, and antioxidants into one delicious green scoop.',
    image:
      'https://drinkag1.com/_next/image?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2Fjf30o7wb%2Fproduction%2F06b384cfc234fdf8bb4f3d12c44a6745309d4057-2048x2048.png&w=1920&q=75',
    price: '$99.00',
    purchaseLink: 'https://drinkag1.com/product/greens-powder-pouch?a=1&tactic=performancemax%3D&nbt=nb%3Aadwords%3Ax%3A21454085003%3A%3A&nb_adtype=pla&nb_kwd=&nb_ti=&nb_mi=117988768&nb_pc=online&nb_pi=US10223&nb_ppi=&nb_placement=&nb_li_ms=&nb_lp_ms=&nb_fii=&nb_ap=&nb_mt=&gclsrc=aw.ds&utm_source=google&utm_medium=cpc&utm_campaign=Test_US_Google_PerformanceMax_Shopping_NB&gad_source=4&gad_campaignid=21447593925&gbraid=0AAAAADvAmD5x8NQZYJlGd-KQQKAeuT3lo&gclid=Cj0KCQiA5uDIBhDAARIsAOxj0CFBKtfRunPiRejt4cIjmg3D_oZ0COEYz_4qzy_EyH6YZsrwTUgWQo4aArtFEALw_wcB&flavor=original',
    category: 'Supplements',
    ingredients:
      'Acerola cherries, apple powder, pea protein isolate, organic spirulina, lecithin phospholipids, inulin (chicory root), chlorella powder, cocoa bean powder, licorice root powder, bromelain, beta-glucan, artichoke aerial part extract, slippery elm bark powder, rhodiola root extract, astragalus root extract, matcha leaf powder, ashwagandha root extract, dandelion herb extract, eleuthero root extract, broccoli powder, papaya fruit powder, beetroot powder, wheatgrass leaf powder, alfalfa leaf powder, barley leaf powder, carrot root powder, acerola fruit extract, rosehip extract, pineapple fruit powder, shiitake mushroom powder, reishi mushroom powder, rutin (from Sophora japonica), rosemary leaf extract, bladderwrack plant powder, wolfberry (Lycium barbarum) extract, burdock root extract, hawthorn berry extract, bilberry extract, milk thistle seed extract, grape seed extract, Lactobacillus rhamnosus GG, Lactobacillus acidophilus NCFM, Bifidobacterium lactis HN019, Lactobacillus casei LC-11, Lactobacillus plantarum LP-115, alpha-lipoic acid, benfotiamine, biotin, boron, calcium, choline, chromium, copper, folate, magnesium, manganese, molybdenum, potassium, selenium, sodium, zinc, CoQ10 (coenzyme Q10), B-complex vitamins (B1, B2, B3, B6, B12, pantothenic acid), vitamin A, vitamin C, vitamin E, vitamin K2.',
    reviews: [
      {
        id: 'r3',
        dietitianName: 'Emma Rodriguez',
        credentials: 'RD, CNSC, Digestive Health Specialist',
        rating: 5,
        comment:
          'I recommend this to clients with IBS and other digestive concerns. The strain diversity and CFU count are excellent, and the addition of prebiotic fiber makes this a complete gut health solution.',
        date: '2023-12-03',
      },
    ],
  },
  {
    id: '3',
    name: 'Mediterranean Meal Delivery',
    shortDescription:
      'Dietitian-designed meals based on the Mediterranean diet',
    description:
      'Weekly delivery of fresh, ready-to-heat meals based on the Mediterranean diet pattern. Each meal is nutritionally balanced and designed by our team of registered dietitians to provide optimal nutrition while delivering authentic Mediterranean flavors.',
    image:
      'https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?q=80&w=2664&auto=format&fit=crop',
    price: '$12.99/meal',
    purchaseLink: 'https://www.hellofresh.com/eat/mediterranean-diet-meal-delivery',
    category: 'Meal Services',
    reviews: [
      {
        id: 'r4',
        dietitianName: 'David Wilson',
        credentials: 'MPH, RD, Cardiovascular Nutrition Specialist',
        rating: 5,
        comment:
          'These meals align perfectly with the evidence-based Mediterranean diet pattern. The balance of healthy fats, lean proteins, and complex carbohydrates is ideal for heart health and weight management.',
        date: '2024-01-10',
      },
      {
        id: 'r5',
        dietitianName: 'Priya Patel',
        credentials: 'MS, RDN, CDE',
        rating: 4,
        comment:
          "I've recommended this service to many clients with diabetes and cardiovascular concerns. The meals are consistently well-balanced with appropriate portions and excellent ingredient quality.",
        date: '2023-11-28',
      },
    ],
  },
  {
    id: '4',
    name: 'Omega-3 Fish Oil',
    shortDescription: 'Pharmaceutical-grade omega-3s with third-party testing',
    description:
      'Nature Made Omega-3 (1) from Fish Oil 1200 mg Softgels are dietary supplements formulated to help support a healthy heart, brain and eyes.',
    image:
      'https://cloudinary.images-iherb.com/image/upload/f_auto,q_auto:eco/images/ndm/ndm02657/l/19.jpg',
    price: '$32.95',
    purchaseLink: 'https://www.cvs.com/shop/nature-made-omega-3-fish-oil-1200-mg-softgels-one-per-day-100-ct-prodid-854409?skuId=854409&cgaa=QWxsb3dHb29nbGVUb0FjY2Vzc0NWU1BhZ2Vz&cid=ps_vit_pla&gclsrc=aw.ds&gad_source=1&gad_campaignid=21089656504&gclid=Cj0KCQiA5uDIBhDAARIsAOxj0CHg5y_TJq2oYlcaPXvruMPuvEQE8O8S8xwCzyma1xVGBmETUKWTgCkaArexEALw_wcB',
    category: 'Supplements',
    ingredients:
      'Fish oil concentrate, gelatin capsule, enteric coating, mixed tocopherols (natural preservative)',
    reviews: [
      {
        id: 'r6',
        dietitianName: 'Jennifer Brown',
        credentials: 'PhD, RD, FAND',
        rating: 5,
        comment:
          'This is one of the few fish oil supplements I recommend to clients. The third-party testing, concentration of EPA/DHA, and sustainable sourcing set it apart from most products on the market.',
        date: '2023-09-15',
      },
    ],
  },
]
// Featured products for homepage
export const featuredProducts = products.slice(0, 3)
// Categories for filtering
export const categories = Array.from(
  new Set(products.map((product) => product.category)),
)
